<div class="frame-container">
  @if (title) {
  <div class="frame-header">
    <h3 title="{{ !showHoverOver ? '' : undefined }}">{{ title }}</h3>
  </div>
  }
  <div class="frame-content">
    <ng-content></ng-content>
  </div>
</div>
